export default __webpack_public_path__ + "static/media/cra.edb534c0.jpg";